<template>
<load-error v-if="loadError"></load-error>
  <div v-else class="ImageBox">
    <div class="ImageBox__content">
      <img
        :src="imgSrc"
        :style="imageStyle"
        alt=""
        loading="lazy"
        @error="onError"
        @load="onLoad"
      />
    </div>

    <div class="swiper-lazy-preloader"></div>
  </div>
</template>

<script>
import LoadError from "./loaderror.vue";

export default {
  components: {
    LoadError,
  },
  props: {
    imgSrc: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    zoomPercent: {
      type: Number,
      default: 1,
    },
    imgRotate: {
      type: Number,
      default: 0,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    imgSrc: {
      handler() {
        this.percent = 1;
        this.rotate = 0;
      },
      immediate: true,
    },
    zoomPercent(val) {
      this.percent = val;
    },
    imgRotate(val) {
      this.rotate = val;
    },
    show(val) {
      if (val && this.loadError) {
        this.loadError = false;
      }
    },
  },
  data() {
    return {
      percent: 1,
      rotate: 0,
      timer: null,
      loadError: false,
    };
  },
  methods: {
    onError() {
      this.loadError = true;
    },
    onLoad() {
      this.$emit("after-load");
      clearTimeout(this.timer);
    },
  },
  computed: {
    imageStyle() {
      return {
        transform: `rotate(${this.rotate}deg) scale(${this.percent})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.ImageBox {
  position: relative;
  width: calc(100% - 64px);
  padding: 45px 32px;

  .ImageBox__content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: calc(100% - 90px);
    overflow: hidden;
    user-select: none;

    img {
      max-width: 100%;
      max-height: 100%;
      transition: transform 0.3s;
    }
  }
}
</style>
